import { action, makeObservable, observable, runInAction } from 'mobx';
import { ingestionApi } from '../ingestionApi';

class IngestionStore {
    @observable items = [];
    @observable loadingList = false;
    @observable listError = null;

    @observable currentItem = null;
    @observable loadingItem = false;
    @observable itemError = null;

    @observable saving = false;

    @observable scrapeSummary = [];
    @observable loadingScrape = false;
    @observable runningStep = false;

    constructor() {
        makeObservable(this);
    }

    @action
    async loadList(filters = {}) {
        this.loadingList = true;
        this.listError = null;
        try {
            const items = await ingestionApi.listItems(filters);
            runInAction(() => {
                this.items = items;
            });
        } catch (e) {
            runInAction(() => {
                this.listError = e.message || 'Failed to load pipeline items';
            });
        } finally {
            runInAction(() => {
                this.loadingList = false;
            });
        }
    }

    @action
    async loadItem(id) {
        this.loadingItem = true;
        this.itemError = null;
        this.currentItem = null;
        try {
            const item = await ingestionApi.getItem(id);
            runInAction(() => {
                this.currentItem = item;
            });
        } catch (e) {
            runInAction(() => {
                this.itemError = e.message || 'Failed to load item';
            });
        } finally {
            runInAction(() => {
                this.loadingItem = false;
            });
        }
    }

    // Refresh the current item in place (for polling) — does NOT null currentItem
    // or toggle loadingItem, so the detail view doesn't flash to a spinner.
    @action
    async refreshCurrentItem(id) {
        try {
            const item = await ingestionApi.getItem(id);
            runInAction(() => {
                this.currentItem = item;
            });
        } catch {
            // keep the last good item on a transient refresh error
        }
    }

    @action
    async createItem(payload) {
        this.saving = true;
        try {
            return await ingestionApi.createItem(payload);
        } finally {
            runInAction(() => {
                this.saving = false;
            });
        }
    }

    @action
    async updateVariations(id, payload) {
        this.saving = true;
        try {
            return await ingestionApi.updateVariations(id, payload);
        } finally {
            runInAction(() => {
                this.saving = false;
            });
        }
    }

    @action
    async runStep(id, step) {
        this.runningStep = true;
        try {
            return await ingestionApi.runStep(id, step);
        } finally {
            runInAction(() => {
                this.runningStep = false;
            });
        }
    }

    @action
    async loadScrapeSummary(id) {
        this.loadingScrape = true;
        try {
            const summary = await ingestionApi.getScrapeSummary(id);
            runInAction(() => {
                this.scrapeSummary = summary;
            });
        } catch (e) {
            runInAction(() => {
                this.scrapeSummary = [];
            });
        } finally {
            runInAction(() => {
                this.loadingScrape = false;
            });
        }
    }
}

export const ingestionStore = new IngestionStore();
